export const colors = [
  'transparent',
  'currentColor',
  'inherit',
  // TODO remove after rebranding
  'neutral-N00',
  'neutral-N02',
  'neutral-N04',
  'neutral-N10',
  'neutral-N20',
  'neutral-N40',
  'neutral-N50',
  'neutral-N80',
  'neutral-N90',
  'neutral-N94',
  'neutral-N99',
  'neutral-dark-N00',
  'neutral-dark-N02',
  'neutral-dark-N04',
  'neutral-dark-N10',
  'neutral-dark-N20',
  'neutral-dark-N40',
  'neutral-dark-N50',
  'neutral-dark-N80',
  'neutral-dark-N90',
  'neutral-dark-N94',
  'neutral-dark-N99',
  'brand-B06',
  'brand-B50',
  'brand-B99',
  'scraping-S06',
  'scraping-S50',
  'scraping-S99',
  'primary-P15',
  'primary-P50',
  'primary-P99',
  'success-S06',
  'success-S50',
  'success-S99',
  'error-E06',
  'error-E50',
  'error-E99',
  'warning-W06',
  'warning-W50',
  'warning-W99',
  'info-I99',
  'gradient-1',
  'gradient-2',
  'gradient-3',
  'gradient',
  'lightGradient',
  // decodo
  'brand-25',
  'brand-50',
  'brand-100',
  'brand-200',
  'brand-300',
  'brand-400',
  'brand-500',
  'brand-600',
  'brand-700',
  'brand-800',
  'brand-900',
  'brand-950',
  'brand-975',
  'success-25',
  'success-50',
  'success-100',
  'success-200',
  'success-300',
  'success-400',
  'success-500',
  'success-600',
  'success-700',
  'success-800',
  'success-900',
  'success-950',
  'error-25',
  'error-50',
  'error-100',
  'error-200',
  'error-300',
  'error-400',
  'error-500',
  'error-600',
  'error-700',
  'error-800',
  'error-900',
  'error-950',
  'warning-25',
  'warning-50',
  'warning-100',
  'warning-200',
  'warning-300',
  'warning-400',
  'warning-500',
  'warning-600',
  'warning-700',
  'warning-800',
  'warning-900',
  'warning-950',
  'gray-25',
  'gray-50',
  'gray-100',
  'gray-200',
  'gray-300',
  'gray-400',
  'gray-500',
  'gray-600',
  'gray-700',
  'gray-800',
  'gray-900',
  'gray-950',
  'gray-dark-25',
  'gray-dark-50',
  'gray-dark-100',
  'gray-dark-200',
  'gray-dark-300',
  'gray-dark-400',
  'gray-dark-500',
  'gray-dark-600',
  'gray-dark-700',
  'gray-dark-800',
  'gray-dark-900',
  'gray-dark-950',
  'secondary-25',
  'secondary-50',
  'secondary-100',
  'secondary-200',
  'secondary-300',
  'secondary-400',
  'secondary-500',
  'secondary-600',
  'secondary-700',
  'secondary-800',
  'secondary-900',
  'secondary-950',
  'tertiary-25',
  'tertiary-50',
  'tertiary-100',
  'tertiary-200',
  'tertiary-300',
  'tertiary-400',
  'tertiary-500',
  'tertiary-600',
  'tertiary-700',
  'tertiary-800',
  'tertiary-900',
  'tertiary-950',
  'base-white',
  'base-black',
  'base-dark-white',
  'base-dark-black',
  'gradient-main',
  'gradient-main-90deg',
  'gradient-secondary-1',
  'gradient-secondary-2',
  'gradient-secondary-3',
  'gradient-secondary-4',
  'gradient-secondary-5',
  'light-gradient',
] as const;

export type Colors = (typeof colors)[number];

export const fontSizes = [
  'xl',
  'l',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'subtitle-l',
  'subtitle-l-d',
  'subtitle-m',
  'blog-body',
  'body-l',
  'body-l-medium',
  'body-l-bold',
  'body-m',
  'body-m-medium',
  'body-m-bold',
  'body-s',
  'body-s-mediun',
  'body-s-bold',
  'button-text-l',
  'button-text-m',
  'button-text-s',
  'label-text-l',
  'label-text-m',
  'label',
  'label-medium',
  'label-s',
  'label-s-medium',
  'code-sample',
] as const;

export type FontSizes = (typeof fontSizes)[number];
